import { render } from "./NavigationBottom.vue?vue&type=template&id=53a9f17e&lang=html"
import script from "./NavigationBottom.vue?vue&type=script&lang=js"
export * from "./NavigationBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__